
// Show or hide fixed elements (like chat button) when opening large components

const handleFixedElements = (display) => {

  // Gorgias chat
  if (window.GorgiasChat) {
    if(display == 'show') {
      GorgiasChat.hideChat(false);
    } else if(display == 'hide') {
      GorgiasChat.hideChat(true);
    }
  }

  // PushEngage widget
  if(document.getElementById('pushengage-subscriber-recovery-widget')) {
    if(display == 'show') {
      document.getElementById('pushengage-subscriber-recovery-widget').style.display = 'block';
    } else if(display == 'hide') {
      document.getElementById('pushengage-subscriber-recovery-widget').style.display = 'none';
    }
  }

  // Product overview video
  if(document.getElementById('product-overview-overlay')) {
    if(display == 'show') {
      document.getElementById('product-overview-overlay').classList.remove('loading');
    } else if(display == 'hide') {
      document.getElementById('product-overview-overlay').classList.add('loading');
    }
  }

  // WhatsApp corner button
  if(document.getElementById('whatsapp-corner-btn')) {
    if(display == 'show') {
      document.getElementById('whatsapp-corner-btn').classList.remove('loading');
    } else if(display == 'hide') {
      document.getElementById('whatsapp-corner-btn').classList.add('loading');
    }
  }

}